export class FiltrosDeudas{
    Codigo: string = '';
    idEmpresa : string = '';
    Estado : string = 'P';
    Moneda : number = 0;
    FechaIni : string = "";
    FechaFin : string = "";
}